import React, { useState } from 'react';

import { Grid } from '@material-ui/core';

import { FetchError } from '../../common/api/api';
import AppSnackbar from '../../common/AppSnackbar';
import DeleteEntityCard from '../../common/cards/DeleteEntityCard';
import { Task } from '../tasks/Task.interface';
import SubTaskListCard from '../tasks/cards/SubTaskListCard';
import TaskStatusCard from '../tasks/cards/TaskStatusCard';
import TaskFileListCard from '../tasks/cards/TaskFileListCard';
import TaskAttachmentCard from '../tasks/cards/TaskAttachmentCard';
import { useTaskEntityFields } from '../workflow/Workflow.hooks';
import { WorkflowEntity } from '../workflow/Workflow.interface';
import ProductComponentCard from './cards/ProductComponentCard';
import ProductDescriptionCard from './cards/ProductDescriptionCard';
import ProductDetailCard from './cards/ProductDetailCard';
import ProductIntendedUseCard from './cards/ProductIntendedUseCard';
import ProductPeopleCard from './cards/ProductPeopleCard';
import ProductRegionsMarketedCard from './cards/ProductRegionsMarketedCard';
import ProductReleaseCard from './cards/ProductReleaseCard';
import { Product } from './Product.interface';
import { useUserContext } from '../../user/User.context';

export interface ProductDetailPageProps {
  product: Product;
  onChange?: (product: Partial<Product>) => void;
}

const ProductDetailPage: React.FC<ProductDetailPageProps> = (
  props: ProductDetailPageProps
) => {
  const { product, onChange } = props;
  const { hasRole } = useUserContext();
  const [error, setError] = useState<FetchError | undefined>();
  const { isFieldDisabled } = useTaskEntityFields<WorkflowEntity.Product>(
    product?.task
  );
  const handleChange = (product: Product) => {
    product.task = { ...product.task };
    onChange?.(product);
  };
  const handleTaskChange = (newTask: Partial<Task>) => {
    Object.assign(product.task, newTask);
    onChange?.({});
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ProductDetailCard product={product} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <ProductDescriptionCard product={product} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <ProductRegionsMarketedCard
              product={product}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <ProductIntendedUseCard product={product} onChange={handleChange} />
          </Grid>
          {product.task && (
            <Grid item xs={12}>
              <TaskAttachmentCard
                task={product.task}
                onError={setError}
                onChange={handleTaskChange}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TaskStatusCard task={product.task} />
          </Grid>
          {product.task?.children && (
            <Grid item xs={12}>
              <SubTaskListCard
                task={product.task}
                title='Stakeholders'
                disabled={isFieldDisabled('assignSubTasks')}
                onError={setError}
                onChange={handleTaskChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <ProductPeopleCard product={product} />
          </Grid>
          {/* <Grid item xs={12}>
            <ProductHistoryCard product={product} />
          </Grid> */}
          <Grid item xs={12}>
            <TaskFileListCard
              task={product.task}
              onError={setError}
              onChange={handleTaskChange}
            />
          </Grid>
          <Grid item xs={12}>
            <ProductComponentCard product={product} />
          </Grid>
          <Grid item xs={12}>
            <ProductReleaseCard product={product} />
          </Grid>
          {hasRole('Delete') && (
            <Grid item xs={12}>
              <DeleteEntityCard
                title='Product'
                apiPath={`products`}
                entity={product}
              />
            </Grid>
          )}
        </Grid>
      </Grid>

      <AppSnackbar
        severity='error'
        open={!!error}
        onClose={() => setError(undefined)}
      >
        {error?.message}
      </AppSnackbar>
    </Grid>
  );
};

export default ProductDetailPage;
